import { omit } from 'lodash';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const pollsDataNormalizer = (componentData) => {
  return __spreadProps(__spreadValues({}, omit(componentData, ["siteToken", "config.enableVoteRole"])), {
    poll: normalizePoll(componentData.poll)
  });
};
const normalizePoll = (poll) => {
  const blackList = [
    "anonymousCount",
    "count",
    "creatorFlag",
    "ownVotes",
    "latestVoters",
    "rating"
  ];
  const normalizedPoll = omit(poll, blackList);
  normalizedPoll.options = poll.options.map((option) => omit(option, blackList));
  return normalizedPoll;
};

export { pollsDataNormalizer as default, normalizePoll };
//# sourceMappingURL=pollsDataNormalizer.js.map
